// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3M4L0","rootSmall":"AddTileButton_rootSmall__idb71"};